<div class="manage-auth-container">
    @if (!canManageAtClientLevel()) {
    <bmt-manage-auth-at-group (viewAuthorizations)="cancelEdit.emit(true)" (cancelGroupAuthEdit)="cancelEdit.emit(true)" [userInfo]="userInfo()"></bmt-manage-auth-at-group>
    } @else {
    <bmt-manage-auth-at-multi-group (cancelGroupAuthEdit)="cancelEdit.emit(true)" [userInfo]="userInfo()"></bmt-manage-auth-at-multi-group>
    }
</div>
